<template>
  <div class="course">
    <div v-if="course">
      <img :src="$thumbnail(club.nid, course.files.image[0].fid, '700x')" class="course-img" v-if="course.files && course.files.image && course.files.image.length">
      <Card :title="course.title">
        <div v-html="course.content" class="course-content"></div>
      </Card>
      <Card>
        <div class="d-flex">
          <Tabs noScroll>
            <Tab title='Info' active>
              <Grid :columns="gridOptions">
                <div v-if="!course.isAdditionalServiceListing">
                  <strong>{{ $t('Wanneer') }}:</strong> {{ dayString }}
                </div>
                <div v-else>
                  <strong>{{ $t(course.type === 'activity' ? 'Datum' : 'Periode') }}:</strong> {{ course.period }}
                </div>
                <div v-if="course.show_sessions_count && !course.isAdditionalServiceListing && activityDuration > 0">
                  <strong>{{ $t('Aantal sessies') }}:</strong> {{ !(Object.values(course.sessions).length > 2) && course.type === 'activity' && !course.isTicketSalesEvent ? course.sessionsCount : Object.values(course.sessions).length }}
                </div>
                <div v-if="displayAgeRestriction && (ageRestrictions || ageRestrictionsByYear)">
                  <strong>{{ $t('Leeftijd') }}:</strong> {{ course.age }}
                </div>
                <div v-if="course.maxAttendeesPerSession && course.show_max_participants || course.isTicketSalesEvent && course.show_max_participants">
                  <strong>{{ $t('Maximum aantal deelnemers') }}:</strong> {{ $tc('course.amount_attendees', course.isTicketSalesEvent ? course.availableSeats : course.maxAttendeesPerSession) }}
                </div>
                <div v-if="course.levelsOnDetail && course.levels.length">
                  <strong>{{ $t('Niveau') }}:</strong> {{ course.levels.map(level => level.title).join(', ') }}
                </div>
                <div v-if="Object.values(course.taxonomyItems).filter(taxonomyItem => taxonomyItem.forDetail).length">
                  <strong>{{ $t('Categorieën') }}:</strong> {{ course.taxonomyItems.filter(taxonomyItem => taxonomyItem.forDetail).map(taxonomyItem => taxonomyItem.title).join(', ') }}
                </div>
                <div v-if="course.isOnlineCourse && course.onlineCourseURL">
                  <strong>{{ $t('Online cursus URL') }}:</strong> <a :href="course.onlineCourseURL" target="_blank">{{ course.onlineCourseURL }}</a>
                </div>
                <div v-if="course.isOnlineCourse && course.onlineCoursePassword">
                  <strong>{{ $t('Online cursus wachtwoord') }}:</strong> {{ course.onlineCoursePassword }}
                </div>
                <div v-if="course.location">
                  <strong>Locatie:</strong> {{ course.location }}
                  <div v-if="course.locationAddress" v-html="course.locationAddress"></div>
                </div>
              </Grid>
            </Tab>
            <Tab v-if="course.show_sessions_calendar && !course.isAdditionalServiceListing" ref="sessionTab" title='Kalender'>
                <FullCalendar v-if="renderCalendar" class="sessions-calendar" ref="calendar" style="max-width:500px;" :options="calendarOptions"></FullCalendar>
                <Modal ref="modal" :title="currentEvent ? currentEvent.title : 'false'">
                  <dl v-if="currentEvent">
                    <dt>{{ $t('Start') }}</dt>
                    <dd>{{ $moment(currentEvent.start).format('DD/MM/YYYY HH:mm') }}</dd>
                    <dt>{{ $t('Eind') }}</dt>
                    <dd>{{ $moment(currentEvent.end).format('DD/MM/YYYY HH:mm') }}</dd>
                    <div v-if="currentEvent && currentEvent.extendedProps && currentEvent.extendedProps.club">
                      <dt>{{ $t('Club') }}</dt>
                      <dd>{{ currentEvent.extendedProps.club.title }}</dd>
                    </div>
                    <div v-else-if="currentEvent && currentEvent.club">
                      <dt>{{ $t('Club') }}</dt>
                      <dd>{{ currentEvent.club.title }}</dd>
                    </div>
                  </dl>
                </Modal>
            </Tab>
            <Tab v-if="course.relatedProducts && course.relatedProducts.length" ref="relatedProductsTab" title="Aanbevolen producten">
              <Grid v-if="course.relatedProducts && course.relatedProducts.length" :columns="{ tablet: 2, desktop: 4 }">
                <WebshopRecommendedItem v-for="(product, index) of course.relatedProducts" :key="index" :item="product"></WebshopRecommendedItem>
              </Grid>
            </Tab>
          </Tabs>
        </div>
      </Card>
      <Alert v-if="course.isOnlineCourse" :type="course.onlineCourseURL ? 'success' : 'info'">
        <h3>{{ $t('Deze cursus is een online cursus') }}</h3>
        <div v-if="course.onlineCourseURL">
          <p><strong>{{ $t('Online link') }}:</strong> <a :href="course.onlineCourseURL" target="_blank">{{ course.onlineCourseURL }}</a>
            <span v-if="course.onlineCoursePassword"><br /><strong>{{ $t('Online wachtwoord') }}:</strong> {{ course.onlineCoursePassword }}</span></p>
        </div>
        <p v-else>De link en het wachtwoord zullen hier weergegeven worden wanneer de inschrijving betaald is.</p>
      </Alert>
      <Alert :title="$t('Deze ' + (course.type === 'activity' ? 'activiteit' : 'cursus') + ' is geannuleerd.')" v-if="course.status === 4">
      </Alert>
      <Alert :title="$t('Opgepast! Deze cursus valt buiten je leeftijdscategorie.')" v-if="ageRestricted && selectedUser && tariffs.length">
        <span v-if="dontAllowApproval">“{{ selectedUser.name }}” valt buiten de leeftijdscategorie en kan niet ingeschreven worden voor deze cursus.</span>
        <span v-else>Als je “{{ selectedUser.name }}” inschrijft voor deze cursus zal dit eerst moeten goedgekeurd worden.</span>
      </Alert>
      <TicketSale :event="course" v-if="course.isTicketSalesEvent && openTariffs.length" />
      <div v-else-if="!course.isAdditionalServiceListing">
        <div v-if="passTariff && course.status !== 4">
          <PassCalendar id="pass-calendar" ref="passCalendar" v-if="currentStep === 'reserve' && events.length" :course="course" :tariff="passTariff" :events="events" @submit="reserve" @cancel="cancelReservation" />
          <Alert :title="$t('Geen reservaties beschikbaar')" v-else-if="currentStep === 'reserve'">
            <div v-if="passRegistrationsStarted === true">
              {{ $t('Alles is reeds volzet.') }}
            </div>
            <div v-else-if="passRegistrationsStarted === false">
              {{ $t('Er zijn geen toekomstige sessies meer.') }}
            </div>
            <div v-else>
              {{ $t('De reservaties zijn nog niet gestart, deze starten pas op') }} {{ passRegistrationsStarted }}
            </div>
          </Alert>
          <Button primary type="button" @click="currentStep = 'index'" v-if="currentStep === 'reserve' && !$route.query.pass">{{ $t('Terug naar alle tarieven') }}</Button>
          <RegistrationForm id="pass-form" v-if="currentStep === 'form' && events.length" ref="registrationForm" :value="registrationFormData" @submit="submitReserve" agreement specificInline />
          <Alert id="pass-success" v-if="currentStep === 'reserve-success'" type="success" :title="$t('Reservatie gelukt!')">
            {{ $t('Je reservatie is gelukt') }}
          </Alert>
        </div>
        <div v-if="trialTariff && !hasNormalRegistration && course.status !== 4">
          <TrialCalendar id="pass-calendar" ref="trialCalendar" v-if="currentStep === 'reserveTrial' && trialEvents.length" :course="course" :tariff="trialTariff" :events="trialEvents" :reservationsPerUser="trialReservationsPerUser" :availableReservations="trialAvailableReservations" @submit="reserveTrial" @cancel="cancelTrialReservation" :loading="trialLoading" :cancelLoading="cancelTrialLoading" />
          <Alert :title="$t('Geen reservaties beschikbaar')" v-else-if="currentStep === 'reserveTrial'">
            <div v-if="trialRegistrationsStarted === true">
              {{ $t('Alles is reeds volzet.') }}
            </div>
            <div v-else-if="trialRegistrationsStarted === false">
              {{ $t('Er zijn geen toekomstige sessies meer.') }}
            </div>
            <div v-else>
              {{ $t('De reservaties zijn nog niet gestart, deze starten pas op') }} {{ trialRegistrationsStarted }}
            </div>
          </Alert>
          <Button primary type="button" @click="currentStep = 'index'" v-if="currentStep === 'reserveTrial' && !$route.query.pass">{{ $t('Terug naar alle tarieven') }}</Button>
        </div>
        <Card class="tariffs" fill v-if="(currentStep === 'index' || currentStep === 'reserve-success') && (tariffs.length || passTariff || trialTariff) && !dontAllowApproval" :blur="!user && club.public_blur_tariffs_logged_out_detail || !selectedUser && club.public_blur_tariffs_logged_out_detail">
          <template v-if="!user" #blur>
            <h2>Log in</h2>
            <p>Log in om de tarieven te bekijken</p>
            <Button primary type="button" fill @click="$router.push({ name: 'Login', query: { redirect: $route.fullPath } })">{{ $t('Inloggen') }}</Button>
          </template>
          <template v-else-if="!selectedUser" #blur>
            <h2>Selecteer een gebruiker</h2>
            <p>Kies een gebruiker om de tarieven te bekijken.</p>

            <UserSelect />
          </template>
          <Alert type="info" v-if="user && !selectedUser" :title="$t('Selecteer gebruiker')">
            <p>{{ $t('Selecteer eerst een gebruiker voor je een tarief kunt selecteren') }}</p>
            <UserSelect :primary="false" />
          </Alert>
          <div v-if="passTariff || (trialTariff && !hasNormalRegistration)">
            <h2>{{ $t('Reserveer een les') }}</h2>
            <Card bordered v-if="passTariff" class="tariff">
              <main>
                <strong>{{ passTariff.title }}</strong><br/>
                {{ $t('van') }} {{ passTariff.start }} {{ $t('t.e.m.') }} {{ passTariff.end }}
              </main>
              <aside v-if="user && selectedUser">
                <Button success fill @click="currentStep = 'reserve'" :disabled="course.status === 4">{{ $t('Reserveer') }}</Button>
              </aside>
              <aside v-else-if="!loading && !user">
                <Button primary type="button" fill @click="$router.push({ name: 'Login', query: { redirect: $route.fullPath } })">{{ $t('Inloggen') }}</Button>
              </aside>
            </Card>
            <Card bordered v-if="trialTariff" class="tariff" :locked="trialTariff.isClosed">
              <main>
                <strong>{{ trialTariff.title }}</strong><br/>
                {{ $t('van') }} {{ trialTariff.start }} {{ $t('t.e.m.') }} {{ trialTariff.end }}
                <p class="text-warning" v-if="trialTariff.blockedRegistrationMessage" v-html="trialTariff.blockedRegistrationMessage"></p>
              </main>
              <aside v-if="!trialTariff.blockedRegistrationMessage && selectedUser && !loading">
                <Button success fill @click="currentStep = 'reserveTrial'" :disabled="dontAllowApproval && ageRestricted">{{ $t('Reserveer') }}</Button>
              </aside>
              <aside v-else-if="!loading && !user">
                <Button primary type="button" fill @click="$router.push({ name: 'Login', query: { redirect: $route.fullPath } })">{{ $t('Inloggen') }}</Button>
              </aside>
            </Card>
          </div>

          <div v-if="tariffs.length">
            <h2 v-if="passTariff">{{ $t('Of kies een tarief') }}</h2>
            <h2 v-else>{{ user ? $t('Kies een tarief') : $t('Dit zijn de tarieven') }}</h2>
            <Alert type="danger" v-if="$v.selectedTariff.$error" :title="$t('Selecteer tarief')">{{ $t('Selecteer eerst een tarief') }}</Alert>
            <div v-if="course.isCoupleCourse && selectedTariff">
              <Tariff v-model="selectedTariff" :tariff="selectedTariff" :course="course" :activeFamilyMembers="activeFamilyMembers" :dontAllowApproval="dontAllowApproval && ageRestricted && selectedUser" />
              <FormGroup><Button primary type="button" @click="selectedTariff = null">{{ $t('Terug naar alle tarieven') }}</Button></FormGroup>
            </div>
            <div v-else>
              <Tariff v-for="(tariff, index) in tariffs" :key="index" v-model="selectedTariff" :tariff="tariff" :course="course" :activeFamilyMembers="activeFamilyMembers" :dontAllowApproval="dontAllowApproval && ageRestricted && selectedUser" />
            </div>
            <CoupleCourseChoice ref="coupleCourseChoice" v-if="selectedTariff && course.isCoupleCourse && !coupleCourseInvite" :course="course" :value="{ coupleCourseChoice, coupleCourseChoiceData, coupleCourseChoiceRole }" @input="handleCoupleCourseInput" />
            <Card primary fill v-else-if="selectedTariff && course.isCoupleCourse">
              Je bent uitgenodigd door {{ coupleCourseInvite.name }} voor dit tarief, voeg deze toe aan je winkelmandje om deze te accepteren
            </Card>
            <Input v-if="course.usersSimultaneous && selectedTariff && selectedTariff.availability > 0" v-model="usersSimultaneousAmount" type="number" label="Hoeveel personen wil je inschrijven?" :min="course.usersSimultaneousMin" :disabled="!selectedTariff" :max="usersSimultaneousMax" :v="$v.usersSimultaneousAmount" />
            <div style="text-align: right;">
              <Button v-if="course.externalRegistrationLink" :href="course.externalRegistrationLink" icon="external-link" target="_blank">Inschrijven</Button>
              <Button v-else-if="course.usersSimultaneous && selectedTariff && selectedTariff.availability > 0" @click="currentStep = 'usersSimultaneous'" primary icon="chevron-right" :disabled="usersSimultaneousAmount < 1 || !selectedTariff">Gegevens invullen</Button>
              <AddToCart v-else-if="!(club.disable_waiting_list && !tariffsAvailable)" :data="{ course, tariff: selectedTariff, coupleCourse: course.isCoupleCourse && !coupleCourseInvite ? { coupleCourseChoice, coupleCourseChoiceData, coupleCourseChoiceRole } : coupleCourseInvite ? { coupleCourseInvite } : false }" :v="$v" :validate="validate" @error="handleError" />
            </div>
          </div>
        </Card>
        <Form v-else-if="currentStep === 'usersSimultaneous'">
          <h2>Gegevens meerdere personen aanvullen</h2>
          <Card v-for="(user, index) in usersSimultaneousUsers" :key="index" :v="$v.usersSimultaneousUsers[index]" @delete="usersSimultaneousUsers.splice(index, 1)" :removeDelete="index === 0">
            <h3>{{ `Deelnemer ${index + 1}` }}</h3>
            <Radio v-if="index !== 0" v-model="user.type" value="child" label="Gezinslid" :v="$v.usersSimultaneousUsers[index].type" />
            <Select v-if="user.type === 'child'" v-model="user.uid" :options="unRegisteredUsers.map(member => ({ value: member.uid, label: member.name }))" placeholder="Selecteer gebruiker" @input="v => index === 0 && v ? $store.commit('user/setSelectedUser', v) : false" :exclude="usersSimultaneousUsers.map(u => u.uid).filter(u => u)" :v="$v.usersSimultaneousUsers[index].uid" />
            <Radio v-if="index !== 0" v-model="user.type" value="invite" label="Iemand anders" :v="$v.usersSimultaneousUsers[index].type" />
            <div v-if="user.type === 'invite'">
              <Input v-model="user.data.fname" label="Voornaam" required :v="$v.usersSimultaneousUsers[index].data.fname" />
              <Input v-model="user.data.lname" label="Naam" required :v="$v.usersSimultaneousUsers[index].data.lname" />
              <Input v-model="user.data.email" type="email" label="E-mailadres" required :v="$v.usersSimultaneousUsers[index].data.email" />
              <Datepicker v-model="user.data.birthdate" label="Geboortedatum" required :v="$v.usersSimultaneousUsers[index].data.birthdate" />
            </div>
          </Card>
          <Alert v-if="$v.usersSimultaneousUsers.$error" type="danger">Je moet minstens {{ $v.usersSimultaneousUsers.$params.minLength.min }} personen toevoegen</Alert>
          <Button icon="plus" primary @click="usersSimultaneousUsers.push({ type: null, data: {} })">Deelnemer toevoegen</Button>
          <div style="text-align: right;">
            <AddToCart :data="{ course, tariff: selectedTariff, usersSimultaneous: usersSimultaneousUsers }" :v="$v" :validate="validate" @error="handleError" />
          </div>
        </Form>
        <Alert v-else-if="currentStep === 'index' && !dontAllowApproval" :title="$t('Inschrijvingsperiode afgelopen')">{{ $t('De inschrijvingsperiode is afgelopen, ga terug naar het overzicht.') }}</Alert>
      </div>
      <Card v-else>
        <AddToCart success fill :data="{ course, tariff: selectedTariff, additionalServiceListing: course.isAdditionalServiceListing }">{{ $t('Registreren') }}</AddToCart>
      </Card>
      <p v-if="currentStep === 'index' || currentStep === 'usersSimultaneous' || $route.query.pass"><Button icon="chevron-left" primary @click="$router.push({ name: $route.query.pass ? 'PassReserve' : 'Club', params: { club: $route.params.club } })">{{ $t('Terug naar overzicht') }}</Button></p>
    </div>
    <Alert type="warning" v-else-if="loading" :title="$t('Cursus aan het laden')">{{ $t('Deze cursus is aan het laden, even geduld.') }}</Alert>
    <Alert type="danger" v-else :title="$t('Cursus niet gevonden')">{{ $t('Deze cursus is niet gevonden, ga terug naar het overzicht.') }}</Alert>
  </div>
</template>

<script>
import api from '@/api'
import Card from '../../components/Core/Card'
import AddToCart from '../../components/Cart/AddToCart'
import Button from '../../components/Core/Button'
import Alert from '../../components/Core/Alert'
import { required, email, minValue, maxValue, minLength, maxLength } from 'vuelidate/lib/validators'
import PassCalendar from '../../components/Pass/PassCalendar'
import RegistrationForm from '../../components/Form/RegistrationForm'
import Grid from '../../components/Core/Grid'
import Tariff from '../../components/Course/Tariff'
import { calcAgeRestrictions, calcAgeRestrictionsByYear, isAgeRestricted, scrollTo, dayString, canRegister, isAlreadyRegistered, isQueued, hasOverlap } from '../../utils'
import FormGroup from '../../components/Core/FormGroup'
import UserSelect from '../../components/Core/UserSelect'
import { convertArrayToObject, sendEvent } from '../../utils/tagmanager'
import { isBirthdate } from '../../utils/validators'
import TicketSale from '../../components/TicketSale/Index'
import FullCalendar from '@fullcalendar/vue'
import nlLocale from '@fullcalendar/core/locales/nl'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import resourceTimegridPlugin from '@fullcalendar/resource-timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import Modal from '../../components/Core/Modal'
import CoupleCourseChoice from '../../components/Course/CoupleCourseChoice'
import Tabs from '../../components/Core/Tabs.vue'
import Tab from '../../components/Core/Tab.vue'
import WebshopRecommendedItem from '../../components/Webshop/WebshopRecommendedItem.vue'
import Input from '../../components/Core/Input'
import moment from 'moment'
import Form from '../../components/Core/Form'
import Radio from '../../components/Core/Radio'
import Select from '../../components/Core/Select'
import Datepicker from '../../components/Core/Datepicker'
import TrialCalendar from '../../components/Course/TrialCalendar.vue'
import Icon from '../../components/Core/Icon.vue'
export default {
  name: 'Course',
  components: {
    Datepicker,
    Select,
    Form,
    Input,
    Radio,
    CoupleCourseChoice,
    TicketSale,
    UserSelect,
    FormGroup,
    Tariff,
    Grid,
    RegistrationForm,
    PassCalendar,
    Alert,
    Button,
    AddToCart,
    Card,
    Modal,
    FullCalendar,
    Tabs,
    Tab,
    WebshopRecommendedItem,
    TrialCalendar,
    Icon
  },
  data () {
    return {
      currentStep: 'index',
      course: false,
      currentEvent: false,
      page: 1,
      selectedTariff: null,
      registrationData: false,
      registrationFormData: false,
      gridOptions: {
        tablet: 2
      },
      coupleCourseChoice: null,
      coupleCourseChoiceData: null,
      coupleCourseChoiceRole: null,
      loading: true,
      loadCalendar: false,
      usersSimultaneousAmount: 1,
      usersSimultaneousStep: 1,
      usersSimultaneousUsers: [],
      activeFamilyMembers: {},
      dontAllowApproval: false,
      trialReservationsPerUser: {},
      trialMaxReservations: 0,
      trialAvailableReservations: 0,
      trialLoading: false,
      cancelTrialLoading: false,
      usersRegisteredForTariff: {}
    }
  },
  validations () {
    const validations = {
      selectedTariff: {
        required
      }
    }

    if (this.course.usersSimultaneous && this.selectedTariff && this.selectedTariff.availability > 0) {
      validations.usersSimultaneousAmount = {
        required,
        minValue: minValue(this.course.usersSimultaneousMin),
        maxValue: maxValue(this.usersSimultaneousMax)
      }
    }

    if (this.usersSimultaneousUsers.length) {
      validations.usersSimultaneousUsers = {
        minLength: minLength(this.course.usersSimultaneousMin),
        maxLength: maxLength(this.usersSimultaneousMax),
        noDuplicates: () => {
          const duplicates = this.usersSimultaneousUsers.filter((user, index, self) => user.uid && index !== self.findIndex((u) => u.uid === user.uid))
          return !duplicates.length
        }
      }

      for (const index in this.usersSimultaneousUsers) {
        const currUser = this.usersSimultaneousUsers[index]

        const validation = {
          type: { required }
        }
        if (currUser.type === 'me' || currUser.type === 'child') {
          validation.uid = { required }
        }
        if (currUser.type === 'invite') {
          validation.data = {
            fname: { required },
            lname: { required },
            email: { required, email },
            birthdate: { required, isBirthdate }
          }
        }

        validations.usersSimultaneousUsers[index] = validation
      }
    }

    return validations
  },
  metaInfo () {
    return {
      title: (this.course ? this.course.title : 'Bezig met laden') + ' - ' + this.club.title
    }
  },
  async mounted () {
    await this.fetchData(true)
    if (this.$route.query.pass) {
      this.currentStep = 'reserve'
    }
    if (this.course.isAdditionalServiceListing) {
      // Select tariff
      this.selectedTariff = this.course.tariffs[0]
    }
    this.loadCalendar = true
    // Get minimum price
    let price
    for (const tariff of this.course.tariffs) {
      tariff.amountSeats = 0
      tariff.amountWheelchairs = 0
      if (!price) price = tariff.price
      else if (price > tariff.price) price = tariff.price
    }

    const taxonomies = {}
    for (const taxonomy in this.course.taxonomies || []) {
      taxonomies[taxonomy] = this.course.taxonomies[taxonomy].items
    }

    sendEvent('view-item', {
      startPrice: price,
      title: this.course.title,
      type: this.course.type,
      tariffs: this.course.tariffs.map(tariff => {
        return {
          title: tariff.title,
          price: tariff.price
        }
      }),
      taxonomies: taxonomies,
      levels: convertArrayToObject(this.course.levels || [])
    })
  },
  computed: {
    usersSimultaneousMax () {
      return Math.min(this.course.usersSimultaneousMax || Infinity, (this.selectedTariff && this.selectedTariff.availability) || 0)
    },
    showOccupation () {
      if (!this.$store.getters['club/showOccupation']) {
        return false
      }
      return this.$store.getters['club/showOccupation']
    },
    renderCalendar () {
      if (!this.loading && this.loadCalendar && this.course.show_sessions_calendar) return this.$refs.sessionTab.getIsActive()
      else return false
    },
    dayString () {
      return dayString(this.course.weekdays)
    },
    displayAgeRestriction () {
      return this.$store.getters['club/isDisplayAgeRestriction']
    },
    activityDuration () {
      if (this.course.type === 'activity') {
        const sessions = Object.keys(this.course.sessions).map((k) => this.course.sessions[k])
        const start = moment.unix(sessions[0].date_raw)
        const end = sessions.length === 1 ? moment.unix(sessions[0].date_raw) : moment.unix(sessions[1].date_raw)
        return end.diff(start, 'd')
      } else {
        return 1
      }
    },
    club () {
      return this.$store.getters['club/club']
    },
    user () {
      return this.$store.getters['user/user']
    },
    users () {
      return this.$store.getters['user/users']
    },
    unRegisteredUsers () {
      if (!this.selectedTariff) return this.users
      return this.users.filter(user => {
        return !isAlreadyRegistered(user, this.selectedTariff)
      })
    },
    familyMembers () {
      return this.users.filter(user => {
        return user.uid !== this.selectedUser.uid
      })
    },
    passRegistrationsStarted () {
      // Calc date on when registrations start
      const daysAhead = this.course.passMaxReservationDays
      const nextSessions = Object.values(this.course.sessions).filter(session => {
        return parseInt(session.date_raw) > parseInt(this.$moment().format('X'))
      })
      if (nextSessions.length === 0) {
        return false
      }
      const firstSession = nextSessions[0]
      const startRegistering = this.$moment.unix(parseInt(firstSession.date_raw)).subtract(daysAhead, 'days')
      if (startRegistering.isAfter(this.$moment())) {
        return startRegistering.format('D MMMM YYYY')
      }
      return true
    },
    trialRegistrationsStarted () {
      const daysAhead = this.course.trialMaxReservationDays
      const time = this.course.trialFirstReservationTime
      const nextSessions = Object.values(this.course.trialReservations).filter(session => {
        return parseInt(session.datetime_raw) > parseInt(this.$moment().format('X'))
      })
      if (nextSessions.length === 0) {
        return false
      }
      const firstSession = nextSessions[0]
      const [hours, minutes] = time.split(':')
      let startRegistering = this.$moment.unix(parseInt(firstSession.datetime_raw)).subtract(daysAhead, 'days')
      if (time && hours && minutes) startRegistering.hour(hours).minute(minutes).unix()
      if (startRegistering.isAfter(this.$moment())) {
        return startRegistering.format('D MMMM YYYY')
      }
      return true
    },
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    tariffs () {
      if (!this.course || !this.course.tariffs) {
        return []
      }
      return this.course.tariffs.filter(tariff => {
        if (['each', 'trial'].includes(tariff.type)) return false

        return true
      })
    },
    tariffsAvailable () {
      let available = false
      this.course.tariffs.forEach((tariff) => {
        if (tariff.availability > 0) {
          available = true
        }
      })
      return available
    },
    openTariffs () {
      return this.tariffs.filter(tariff => {
        return !tariff.blockedRegistrationMessage
      })
    },
    passTariff () {
      if (!this.course || !this.course.tariffs) {
        return false
      }
      const tariffs = this.course.tariffs.filter(tariff => tariff.type === 'each')
      console.log({tariffs})
      if (tariffs.length === 0) return false
      return tariffs[0]
    },
    trialTariff () {
      if (!this.course || !this.course.tariffs) {
        return false
      }
      const tariffs = this.course.tariffs.filter(tariff => tariff.type === 'trial' && tariff.status)
      if (tariffs.length === 0) return false
      return tariffs[0]
    },
    events () {
      const events = []
      if (this.course.reservations) {
        for (const reservation of this.course.reservations) {
          events.push({
            date: this.$moment.unix(reservation.date_raw),
            availability: Math.max(0, parseInt(reservation.availability)),
            startTime: reservation.time[0],
            endTime: reservation.time[1],
            nid: reservation.nid,
            allow_cancellation: reservation.allow_cancellation,
            reservations: reservation.reservations.map(reservation => {
              return {
                uid: reservation[0],
                name: reservation[1]
              }
            })
          })
        }
      }
      return events
    },
    trialEvents () {
      const events = []
      if (this.trialRegistrationsStarted !== true) return []
      if (this.course.trialReservations) {
        for (const reservation of this.course.trialReservations) {
          events.push({
            date: this.$moment.unix(reservation.date_raw),
            availability: Math.max(0, parseInt(reservation.availability)),
            startTime: reservation.time[0],
            endTime: reservation.time[1],
            nid: reservation.nid,
            allow_cancellation: reservation.allow_cancellation,
            reservations: reservation.reservations.map(reservation => {
              return {
                uid: reservation[0],
                name: reservation[1]
              }
            })
          })
        }
      }
      return events
    },
    ageRestrictions () {
      return calcAgeRestrictions(this.course)
    },
    ageRestrictionsByYear () {
      return calcAgeRestrictionsByYear(this.course)
    },
    ageRestricted () {
      return isAgeRestricted(this.selectedUser, this.course)
    },
    isInvited () {
      if (!this.selectedTariff) return false
      return this.selectedTariff.invites[this.selectedUser.uid]
    },
    coupleCourseInvite () {
      if (!this.course.isCoupleCourse) return false
      if (!this.selectedTariff) return false
      return this.course.coupleCourseInvitesPerTariff && this.course.coupleCourseInvitesPerTariff[this.selectedTariff.nid] && this.course.coupleCourseInvitesPerTariff[this.selectedTariff.nid][this.user.uid] && Object.values(this.course.coupleCourseInvitesPerTariff[this.selectedTariff.nid][this.user.uid])[0]
    },
    calendarEvents () {
      const vm = this
      const sessionsArr = Object.keys(this.course.sessions).map((k) => this.course.sessions[k])
      const events = []
      sessionsArr.forEach((session) => {
        const startDate = vm.$moment.unix(session.date_raw)
        const endDate = this.course.isTicketSalesEvent && sessionsArr[1] ? vm.$moment.unix(sessionsArr[1].date_raw) : vm.$moment.unix(session.date_raw)
        const endTime = this.course.isTicketSalesEvent && sessionsArr[1] ? sessionsArr[1].time[1] : session.time[1]
        events.push({
          title: `Sessie op ${startDate.format('dddd')}`,
          start: startDate.format('YYYY-MM-DD') + 'T' + session.time[0],
          end: endDate.format('YYYY-MM-DD') + 'T' + endTime,
          date_raw: session.date_raw,
          backgroundColor: '#38afe2',
          textColor: '#fff',
          sessions: [{
            label: 'les',
            from: vm.$moment.unix(session.date_raw).format('DD-MM-YYYY') + ' ' + session.time[0],
            to: vm.$moment.unix(session.date_raw).format('DD-MM-YYYY') + ' ' + session.time[1]
          }]
        })
      })
      if (events.length === 2 && vm.$moment.unix(events[0].date_raw).isSame(vm.$moment.unix(events[1].date_raw))) {
        events[0].end = events[1].end
        events.splice(1, 1)
      }
      return events
    },
    calendarOptions () {
      const vm = this
      const now = new Date()
      const firstFollowingSession = this.calendarEvents.find((cEvent) => {
        const properDate = new Date(cEvent.start)
        if (properDate >= now) return cEvent
      })
      return {
        height: 'auto',
        displayEventTime: false,
        eventClassNames: function (args) {
          if (args.event) {
            return 'isEvent'
          }
        },
        eventDidMount: function (e) {
          const allEvents = e.el.getRootNode().querySelectorAll('.isEvent')
          allEvents.forEach((event) => {
            event.closest('.fc-daygrid-day-frame').querySelector('.fc-daygrid-day-top .fc-daygrid-day-number').style.color = 'white'
            event.closest('.fc-daygrid-day-frame').querySelector('.fc-daygrid-day-top .fc-daygrid-day-number').style.cursor = 'pointer'
            event.closest('.fc-daygrid-day-frame').querySelector('.fc-daygrid-day-top').style.opacity = '1'
            e.el.closest('.fc-daygrid-day-frame').querySelector('.fc-daygrid-day-top .fc-daygrid-day-number').addEventListener('click', function () {
              vm.eventClick(e.event)
            })
          })
        },
        plugins: [
          resourceTimelinePlugin,
          resourceTimegridPlugin,
          dayGridPlugin
        ],
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        initialDate: this.calendarEvents.length ? (firstFollowingSession && firstFollowingSession.start) : now,
        initialView: 'dayGridMonth',
        locale: nlLocale,
        events: this.calendarEvents,
        eventClick: (info) => {
          this.eventClick(info.event)
        }
      }
    },
    paginatedEventsMobile () {
      return this.calendarEvents.slice((this.page - 1) * this.pagination.perPage, this.page * this.pagination.perPage)
    },
    pagination () {
      const perPage = 5
      return {
        perPage: perPage,
        total: this.calendarEvents.length,
        pages: Math.ceil(this.calendarEvents.length / perPage)
      }
    },
    hasNormalRegistration () {
      if (!this.selectedUser) return false
      return this.usersRegisteredForTariff[this.selectedUser.uid]
    }
  },
  methods: {
    async fetchData (initialFetch = false) {
      if (!initialFetch && !this.selectedUser) return
      try {
        const params = {
          club: this.club.nid
        }
        if (!isNaN(this.$route.params.course)) {
          params.nid = this.$route.params.course
        } else {
          params.url = this.$route.params.course
        }
        if (this.$store.getters['user/selectedUser']) {
          params.uid = this.$store.getters['user/selectedUser'].uid
        }
        if (this.$route.query['revoke-queue-invite']) {
          params.revokeQueueInvite = 1
        }

        // Check if any tariffs in cart, used for checking restrictions
        params.tariffsInCart = this.$store.getters['cart/tariffNids']

        this.loading = true
        const response = await api.get('get_public_course_data', params, {
          loading: true
        })
        if (response.data.result.url !== this.$route.params.course) {
          await this.$router.replace({ params: { ...this.$route.params, course: response.data.result.url } })
        }
        this.dontAllowApproval = response.data.dontAllowApproval
        const { result } = response.data
        this.course = {
          ...result
        }
        this.activeFamilyMembers = response.data.activeFamilyMembers
        this.trialReservationsPerUser = response.data.trialReservationsPerUser || {}
        this.trialAvailableReservations = response.data.availableTrialReservations || 0
        this.usersRegisteredForTariff = response.data.usersRegisteredForTariff || {}
        if (this.course.isTicketSalesEvent) {
          if (!this.selectedUser && this.user) this.$store.commit('user/setSelectedUser', this.user.uid)
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$store.commit('notice/addNotices', {
          title: 'Cursus niet gevonden',
          message: 'Cursus niet gevonden',
          type: 'error'
        })
      }
    },
    async reserve (data) {
      const response = await api.post('get_user_reservation_approval', data)
      this.registrationFormData = response.data.result.map(section => {
        section.fields = section.fields.map(field => {
          field.answer = field.last_answer || field.default_value
          return field
        })
        return section
      })
      this.registrationData = data
      this.currentStep = 'form'
    },
    async cancelReservation ({ tariff, session, uid }) {
      try {
        await api.post('cancel_pass_reservation', {
          uid,
          club: this.club.nid,
          tariff,
          session
        })
        this.$store.commit('notice/addNotices', {
          title: 'Reservatie geannuleerd',
          message: 'Je reservatie is succesvol geannuleerd',
          type: 'success'
        })
        await this.fetchData()
        this.$refs.passCalendar.fetchData()
      } catch (err) {
        this.$store.commit('notice/addNotices', {
          title: 'Reservatie annuleren mislukt',
          message: 'Reservatie kon niet geannuleerd worden, contacteer je clubbeheerder',
          type: 'error'
        })
      }
    },
    async cancelTrialReservation ({ tariff, session, uid }) {
      try {
        this.cancelTrialLoading = true
        await api.post('cancel_trial_reservation', {
          uid,
          club: this.club.nid,
          tariff,
          session
        })
        this.$store.commit('notice/addNotices', {
          title: 'Reservatie geannuleerd',
          message: 'Je reservatie is succesvol geannuleerd',
          type: 'success'
        })
        await this.fetchData()
      } catch (err) {
        this.$store.commit('notice/addNotices', {
          title: 'Reservatie annuleren mislukt',
          message: err.message ? this.$t(err.message) : 'Reservatie kon niet geannuleerd worden, contacteer je clubbeheerder',
          type: 'error'
        })
      } finally {
        this.cancelTrialLoading = false
      }
    },
    async submitReserve () {
      try {
        await api.post('submit_user_pass_reservation', {
          ...this.registrationData,
          formData: this.$refs.registrationForm.getFormData()
        })
          this.currentStep = 'reserve-success'
        await this.fetchData()
      } catch (err) {
        this.$store.commit('notice/addNotices', {
          title: 'Reservatie mislukt',
          message: 'Reservatie is niet gelukt, contacteer je clubbeheerder.',
          type: 'error'
        })
      }
    },
    async reserveTrial () {
      // Add to cart
      this.trialLoading = true
      const reservationData = {
        course: this.course,
        tariff: this.trialTariff,
        session: this.$route.query.nid,
        coupleCourse: this.course.isCoupleCourse && !this.coupleCourseInvite ? { coupleCourseChoice: this.coupleCourseChoice, coupleCourseChoiceData: this.coupleCourseChoiceData, coupleCourseChoiceRole: this.coupleCourseChoiceRole } : this.coupleCourseInvite ? { coupleCourseInvite: this.coupleCourseInvite } : false
      }
      await this.$store.dispatch('cart/addItem', reservationData)
      // Go to cart
      this.$router.push({ name: 'Cart' })
      this.trialLoading = false
    },
    handleCoupleCourseInput ({ coupleCourseChoice, coupleCourseChoiceData, coupleCourseChoiceRole }) {
      this.coupleCourseChoice = coupleCourseChoice
      this.coupleCourseChoiceData = coupleCourseChoiceData
      this.coupleCourseChoiceRole = coupleCourseChoiceRole
    },
    validate () {
      if (this.$refs.coupleCourseChoice) {
        this.$refs.coupleCourseChoice.$v.$touch()
        if (this.$refs.coupleCourseChoice.$v.$invalid) return false
      }
      return true
    },
    handleError (v) {
      if (v.selectedTariff.$error) {
        this.$store.commit('notice/addNotices', {
          title: this.$t('Tarief verplicht'),
          message: this.$t('Selecteer eerst een tarief.'),
          type: 'error'
        })
      }
    },
    eventClick (event) {
      this.currentEvent = event
      this.$refs.modal.show()
    },
    hasOverlap (tariff) {
      return hasOverlap({ ...tariff, course: this.course }, [...this.$store.state.cart.tariffs, ...this.otherRegisteredTariffs(tariff)])
    },
    isInCart (tariff) {
      const cart = this.$store.getters['cart/cart']
      const items = cart.items
      return items.find(item => {
        return parseInt(item.nid) === parseInt(tariff.nid) && item.tariff
      })
    },
    isAlreadyRegistered (tariff) {
      return isAlreadyRegistered(this.selectedUser, tariff)
    },
    isQueued (tariff) {
      return isQueued(this.selectedUser, tariff)
    },
    otherTariffs (tariffParam) {
      return this.course.tariffs.filter(tariff => {
        return parseInt(tariff.nid) !== parseInt(tariffParam.nid)
      }).map(tariff => {
        return {
          ...tariff,
          course: this.course
        }
      })
    },
    otherRegisteredTariffs (tariffParam) {
      return this.otherTariffs(tariffParam).filter(tariff => {
        return tariff.registeredUsersPerTariff[this.selectedUser.uid]
      })
    }
  },
  watch: {
    selectedTariff () {
      this.$v.selectedTariff.$touch()
    },
    club () {
      this.$router.push({ name: 'Club', params: { club: this.club.url } })
    },
    currentStep () {
      if (this.currentStep === 'reserve') {
        scrollTo('#pass-calendar')
      }
      if (this.currentStep === 'form') {
        scrollTo('#pass-form')
      }
      if (this.currentStep === 'reserve-success') {
        scrollTo('#pass-success', 150)
      }
      if (this.currentStep === 'usersSimultaneous') {
        this.usersSimultaneousUsers.push({
          uid: this.selectedUser.uid,
          type: 'child'
        })
        for (let i = 1; i < this.usersSimultaneousAmount; i++) {
          this.usersSimultaneousUsers.push({
            uid: null,
            type: null,
            data: {
              fname: '',
              lname: '',
              email: '',
              birthdate: ''
            }
          })
        }
      }
    },
    async selectedUser () {
      await this.fetchData()
      if (this.$route.params.tariff) {
        const tariff = this.tariffs.find((tariff) => parseInt(tariff.nid) === parseInt(this.$route.params.tariff))
        if (canRegister) {
          if (tariff && !this.isInCart(tariff) && !this.hasOverlap(tariff) && !this.isQueued(tariff)) this.selectedTariff = tariff
        }
      }
      if (this.currentStep === 'reserveTrial' && this.selectedUser && this.hasNormalRegistration) this.currentStep = 'index'
    }
  }
}
</script>

<style lang="scss">
.course-img {
  border-radius: var(--border-radius);
  box-shadow: 0 3px 6px rgba(#000, 0.16);
  margin-bottom: 1.5rem;
}
.course-content {
  ul,
  ol {
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  ul {
    list-style-type: disc;
  }
  ol {
    list-style-type: decimal;
  }
}
.nav-item {
  margin-right:2px;
}
.tariff {
  display: flex;

  > main {
    flex-grow: 1;
    > main {
      flex-grow: 1;
    }
  }
}
.sessions-calendar {
  .fc-daygrid-day {
    height:78px;
  }
  .fc-daygrid-dot-event .fc-event-title {
    display: none;
  }
  .fc-daygrid-day-top {
    position: absolute;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .fc-daygrid-day-top .fc-daygrid-day-number {
    z-index: 9;
  }
  .fc-daygrid-dot-event:hover {
    background:transparent;
  }
  .fc-daygrid-event {
    height: 60px;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fc-daygrid-dot-event {
    z-index:8
  }
  .fc-daygrid-event-dot {
    border-radius: 50%;
    position: relative;
    width: 40px;
    height: 40px;
    top: 7px;
    left: -2px;
    background-color: var(--primary-color);
    border: none;
  }
  .fc-scrollgrid-section-sticky > * {
    position: inherit;
  }
  .fc-event-selected, .fc-event:focus {
    box-shadow: none;
  }
  .fc-event-selected:after, .fc-event:focus:after {
    content: none;
    position: initial;
    background: transparent;
  }
  .fc-event-selected:before, .fc-event:focus:before {
    position: initial;
    content: none;
  }
}
@media screen and (min-width: 768px) {
  .tariff > main {
    display: flex;
  }
}
@media screen and (max-width: 420px) {
  .sessions-calendar .fc-daygrid-event-dot {
    width: 30px;
    height: 30px;
  }
}
@import "../../assets/css/calendar.scss";
</style>
